import { render } from "./Browser.vue?vue&type=template&id=ee7bc986"
import script from "./Browser.vue?vue&type=script&lang=js"
export * from "./Browser.vue?vue&type=script&lang=js"

import "./Browser.vue?vue&type=style&index=0&id=ee7bc986&lang=css"

import exportComponent from "/tmp/workspace1/source/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__